import React from "react";
import "./InputComponent.scss"
import PhoneInput from 'react-phone-number-input'

const PhoneInputComponent = ({ value, onChange, placeholder, required, error, errorText, disable, onClick }) => {
    return (
        <div className="PhoneInputComponent-RewardsTick">
            <div className={`PhoneInputComponent-RewardsTick-container ${error ? "error" : disable ? "disable" : ""}`}>
                <PhoneInput
                    defaultCountry="GB"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className="PhoneInputComponent-RewardsTick-container-input"
                    disabled={disable ?? false}

                />
                <div className="PhoneInputComponent-RewardsTick-container-send"
                    onClick={onClick}>
                    Send
                </div>
            </div>
            {errorText !== "" && < div className="input-error-text">
                {errorText}
            </div>}
        </div>
    )
}
export default PhoneInputComponent